<template lang="pug">
  .game-slide(:style="style")
    .bg(:style="style")
    .game
      .header
        .title
          .icon
            img(src="/assets/games/pong/pong.png")
          .name
            span(:style="{ color: game.colors.text }") {{ game.name }}
          .genre
            span(:style="{ color: game.colors.muted }") {{ game.genre }}
        a.play(:href="playLink")
          .icon
            svg(viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M0 0L24.8889 16L0 32V0Z" :fill="game.colors.text")
          span(:style="{ color: game.colors.text }") Play
      .video
        .controls
          .icon(@click="toggleMute()")
            span(v-if="muted") &#x1F508;
            span(v-else) &#x1F50A;
          .icon(@click="playVideo()")
            span &#x1F504;
        video(@click="togglePlay()" autoplay loop muted playsinline)
          source(:src="videoSource" type="video/mp4")
</template>

<script>

export default {
  name: "GameSlide",
  props: {
    game: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      muted: true,
      paused: false
    }
  },
  computed: {
    style() {
      const rgb = this.hexToRGB(this.game.colors.base)
      return {
        backgroundImage: `linear-gradient(to bottom, 
          rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1), 
          rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.3), 
          rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0), 
          rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.3), 
          rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1)), 
          url(/assets/games/${this.game.slug}/${this.game.assets.gif})`,
      }
    },
    videoSource() {
      return `/assets/games/${this.game.slug}/${this.game.assets.video}`
    },
    playLink() {
      return `/games/${this.game.slug}`
    }
  },
  methods: {
    playVideo() {
      const video = document.querySelector('video')
      video.pause()
      video.currentTime = 0
      video.load()
    },
    toggleMute() {
      const video = document.querySelector('video')
      video.muted = !this.muted
      this.muted = !this.muted
      console.log('works2')
    },
    togglePlay() {
      const video = document.querySelector('video')
      if (Math.abs(video.duration - video.currentTime) < 1) {
        this.playVideo()
        this.paused = false
      }
      else {
        if (this.paused) video.play()
        else video.pause()
        this.paused = !this.paused
      }
    },
    hexToRGB(hex) {
      const rgbArray = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return rgbArray ? {
        r: parseInt(rgbArray[1], 16),
        g: parseInt(rgbArray[2], 16),
        b: parseInt(rgbArray[3], 16)
      } : null;
    }
  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css2?family=Oxanium:wght@200;300;400;500;600;700;800&display=swap')

.game-slide
  background-position center
  background-repeat no-repeat
  background-size cover
  position relative
  width 100vw
  height 100vh
  > .bg
    background-position center
    background-repeat no-repeat
    background-size cover
    filter blur(sm2)
    position absolute
    top 0
    left 0
    width 100%
    height 100%
  > .game
    display flex
    flex-direction column
    justify-content center
    margin auto
    position absolute
    top 50%
    left 50%
    width 100%
    height 100%
    max-width 95%
    max-height 80%
    transform translate(-50%, -50%)
    > .header
      display flex
      justify-content space-between
      align-items flex-end
      margin-bottom s0
      > .title
        display grid
        grid-template-columns auto auto
        grid-template-rows auto auto
        column-gap sm2
        > .icon
          grid-column 1/2
          grid-row 1/2
          > img
            height sp3
        > .name
          display flex
          align-items center
          grid-column 2/3
          grid-row 1/2
          > span
            font-size tp2
            font-weight 600
        > .genre
          grid-column 2/3
          grid-row 2/3
          text-transform capitalize
          > span
            font-size t0
      > a.play
        cursor-pointer()
        display flex
        align-items center
        text-decoration none
        transition all 0.1s ease-in-out
        &:hover
          transform scale(1.05)
        > .icon
          margin-right sm2
          > svg
            height t0
            width t0
            > path
              transition all 0.1s ease-in-out
        > span
          font-size tp3
          font-weight 700
    > .video
      bs2(rgba(black, 0.4))
      cursor-pointer()
      position relative
      width 100%
      &:hover
        > .controls
          opacity 1
          > .icon > span
            transform scale(1.12)
      > .controls
        display flex
        position absolute
        bottom s0
        right s0
        opacity 0.4
        transition opacity 0.2s ease-in-out
        z-index 10
        > .icon
          margin-left sm2
          > span
            ts2(rgba(black, 0.8))
            transition all 0.1s ease-in-out
      > video
        width 100%
    @media (min-width: 580px)
      > .video > .controls 
        bottom sp2
        right sp2
        > .icon > span
          font-size tp2
    @media (min-width: 768px)
      > .header 
        > .title 
          > .icon > img
            height sp4
          > .name > span
            font-size tp4
          > .genre > span
            font-size tp2
        > a.play  
          > .icon > svg
            height tp3
            width tp3
          > span
            font-size tp5
      > .video > .controls 
        bottom sp3
        > .icon 
          margin-left s0
          > span
            font-size tp3
    @media (min-width: 1080px)
      max-width 85%
      > .video > .controls > .icon > span
            font-size tp4
    @media (min-width: 1366px)
      max-width 75%
    @media (min-width: 1600px)
      max-width 70%

</style>